import React from "react";
import HomeTab from "./HomeTab";
import { GetMe } from "../../../../lib/api/queries/MeQuery";
import { personNameWithFallback } from "../../../../lib/formatters/personFormatter";

export const HomeTabContainer = () => {
  const name = personNameWithFallback(GetMe().data?.me?.person);

  return <HomeTab name={name} />;
};
